import React, { Fragment } from 'react';
import Page from './Page';
import _ from 'lodash';
import { TextField, Button } from 'material-ui';
import Select from './Select';
import Tooltips from './Tooltips';
import PlusIcon from 'material-ui-icons/AddCircleOutline';
import DeleteIcon from 'material-ui-icons/Delete';

import {
	RACE_OPTIONS,
	EDUCATION_OPTIONS,
	MARRIAGE_OPTIONS,
	STATE_OPTIONS,
	GENDER_OPTIONS,
	DAY_OPTIONS,
	MONTH_OPTIONS,
	YEAR_OPTIONS,
	COLOR_BLIND_OPTIONS,
} from './MyProfile';

const OPERATOR_OPTIONS = [
	{ value: 'any', label: 'is set' },
	{ value: '=', label: '=',  },
	{ value: '!=', label: '!=' },
	{ value: '>', label: '>' },
	{ value: '<', label: '<' },
	{ value: 'within', label: 'within (inclusive)' },
];

const OPERATOR_OPTIONS_SIMPLE = [
	{ value: 'any', label: 'is set' },
	{ value: '=', label: '=' },
	{ value: '!=', label: '!=' },
];

const PROFILE_FIELDS =  {
	'':              { label: '', operatorOptions:OPERATOR_OPTIONS_SIMPLE },
	birthDay:        { label: 'Day of Birth',              options: DAY_OPTIONS,       operatorOptions:OPERATOR_OPTIONS },
	birthMonth:      { label: 'Month of Birth',             options: MONTH_OPTIONS,      operatorOptions:OPERATOR_OPTIONS },
	birthYear:       { label: 'Year of Birth',              options: YEAR_OPTIONS,       operatorOptions:OPERATOR_OPTIONS },
	gender:          { label: 'Gender',                     options: GENDER_OPTIONS,     operatorOptions:OPERATOR_OPTIONS_SIMPLE },
	race:            { label: 'Race/Ethnicity',             options: RACE_OPTIONS,       operatorOptions:OPERATOR_OPTIONS_SIMPLE },
	educationLevel:  { label: 'Highest Level of Education', options: EDUCATION_OPTIONS,  operatorOptions:OPERATOR_OPTIONS },
	householdIncome: { label: 'Household Income',           operatorOptions:OPERATOR_OPTIONS },
	marriageStatus:  { label: 'Marriage Status',            options: MARRIAGE_OPTIONS,   operatorOptions:OPERATOR_OPTIONS_SIMPLE },
	city:            { label: 'City',  operatorOptions:OPERATOR_OPTIONS_SIMPLE },
	state:           { label: 'State', options: STATE_OPTIONS, operatorOptions:OPERATOR_OPTIONS_SIMPLE },
	zip:             { label: 'Zip',  operatorOptions:OPERATOR_OPTIONS_SIMPLE},
	colorBlind:      { label: 'Color Blindness', options:COLOR_BLIND_OPTIONS,  operatorOptions:OPERATOR_OPTIONS_SIMPLE},
}

_.each(PROFILE_FIELDS, (field, key) =>{ field.value = key; });

const FIELD_OPTIONS = _.toArray(PROFILE_FIELDS);


export default class ExperimentDetails extends Page {

	updateStartIfNeeded(newStatus){
		let experiment = this.app.experiment.detailsTemp;
		
		if(newStatus === 'active'){
			if(!experiment.name){
				this.app.showFlashMessage({color:'red', label:'You must set a name for the experiment before you can activate.'});
				return;
			}
			if(+experiment.participantCap < 1 ){
				this.app.showFlashMessage({color:'red', label:'You must set a participant cap before you can activate.'});
				return;
			}
			if(+experiment.time < 1){
				this.app.showFlashMessage({color:'red', label:'You must set an estimated time for the experiment before you can activate.'});
				return;
			}
		}

		experiment.status = newStatus;
	}

	render(){
		let experiment = this.app.experiment.detailsTemp;

		return (
			<div>
				<div style={{position:'absolute', top:'20px', right:'20px'}}>
					<Button style={{marginRight:'15px'}} variant='raised' onClick={() => {this.app.closeFullScreenDialog(); }}>Cancel</Button>
					<Button  variant='raised' color='primary' onClick={() => {this.app.experiment.attemptToSaveDetails(); }}>Save</Button>
				</div>

				<TextField
					id="title"
					label="Name"
					value={experiment.name || ''}
					onChange={ e =>{ experiment.name = e.currentTarget.value; this.app.forceUpdate(); } }
					margin="normal"
					inputProps={{ maxLength:80}}
					fullWidth
					/>

				<TextField
					id="description"
					label="Description"
					value={experiment.description || ''}
					onChange={ e =>{ experiment.description = e.currentTarget.value; this.app.forceUpdate(); } }
					margin="normal"
					fullWidth
					multiline
					inputProps={{ maxLength:700}}
					rowsMax="10"
					/>

				<TextField
					id="time"
					label="Estimated Time In Minutes"
					type="number"
					style={{ marginRight:'15px', width:'200px'}}
					value={experiment.time || ''}
					onChange={ e =>{ experiment.time = e.currentTarget.value; this.app.forceUpdate(); } }
					margin="normal"
					InputLabelProps={{ shrink: true }}
					inputProps={{ maxLength:3}}
					/>

				<TextField
					id="participant-cap"
					label={<span>Participant Cap <Tooltips id="participantCap" /></span>}
					type="number"
					style={{ marginRight:'15px'}}
					value={experiment.participantCap || ''}
					onChange={ e =>{ experiment.participantCap = e.currentTarget.value; this.app.forceUpdate(); } }
					InputLabelProps={{ shrink: true }}
					margin="normal"
					/>

				<TextField
					id="incentive"
					label={<span>Incentive (in USD) <Tooltips id="incentive" /></span>}
					type="number"
					value={experiment.incentive || ''}
					onChange={ e =>{ experiment.incentive = e.currentTarget.value; this.app.forceUpdate(); } }
					InputLabelProps={{ shrink: true }}
					margin="normal"
					/>
				<br />
				<Select
					label={<span>Status <Tooltips id="status" /></span>}
					id="status"
					value={experiment.status}
					onChange={ o =>{ this.updateStartIfNeeded(o.value); this.app.forceUpdate(); } }
					options={this.app.STATUS_OPTIONS}
					/>

				<div style={{margin:'40px 0 0 0'}}>
					<div style={{margin:'0 0 10px 0', fontSize:'13px'}}>
						Allow participants who match all the following (similar rules are OR'ed together) <Tooltips id="rules" />:
					</div>
					{ experiment.rules.map( (rule, i) => 
						<div key={i}>
							<Select
								className="Audience-field"
								value={rule.field}
								onChange={ o =>{ rule.field = o.value; rule.value=''; rule.operator='any'; delete rule.min; delete rule.max; this.app.forceUpdate(); } }
								options={FIELD_OPTIONS}
								/>
							
							<Spacer />

							<Select
								className="Audience-operator"
								value={rule.operator}
								onChange={ o =>{ rule.operator = o.value; this.app.forceUpdate(); } }
								options={ PROFILE_FIELDS[rule.field].operatorOptions }
								/>
							
							<Spacer />
							{rule.operator === 'within' && !!PROFILE_FIELDS[rule.field].options &&
								<Fragment>
									<Select
										className="Audience-value"
										value={rule.min}
										label="Min"
										onChange={ o =>{ rule.min = _.get(o, 'value', o); this.app.forceUpdate(); } }
										options={ PROFILE_FIELDS[rule.field].options }
										/>
										<Spacer />
										<Select
										className="Audience-value"
										label="Max"
										value={rule.max}
										onChange={ o =>{ rule.max = _.get(o, 'value', o); this.app.forceUpdate(); } }
										options={ PROFILE_FIELDS[rule.field].options }
										/>
								</Fragment>
							}
							{rule.operator === 'within' && !PROFILE_FIELDS[rule.field].options &&
								<Fragment>
									<TextField
										className="Audience-value"
										label="Min"
										value={rule.min || ''}
										onChange={ e =>{ rule.min = e.currentTarget.value; this.app.forceUpdate(); } }
										/>
									<Spacer />
									<TextField
										className="Audience-value"
										label="Max"
										value={rule.max || ''}
										onChange={ e =>{ rule.max = e.currentTarget.value; this.app.forceUpdate(); } }
										/>
								</Fragment>
							}
							{rule.operator !== 'any' && rule.operator !== 'within' && !!PROFILE_FIELDS[rule.field].options &&
								<Select
									className="Audience-value"
									value={rule.value}
									onChange={ o =>{ rule.value = _.get(o, 'value', o); this.app.forceUpdate(); } }
									options={ PROFILE_FIELDS[rule.field].options }
									/>
							}
							{rule.operator !== 'any' && rule.operator !== 'within' && !PROFILE_FIELDS[rule.field].options &&
								<TextField
									className="Audience-value"
									label="Value"
									value={rule.value || ''}
									onChange={ e =>{ rule.value = e.currentTarget.value; this.app.forceUpdate(); } }
									/>
							}
							
							<Spacer />
							<DeleteIcon className='opacity-hover' style={{position:'relative', top:'13px'}} onClick={() => {_.pull(experiment.rules, rule); this.app.forceUpdate();}}/>

						</div>
					)}
					<div>
						<span className='a' onClick={() => {experiment.rules.push({field:'', operator:'=', value:''}); this.app.forceUpdate();}}><PlusIcon style={{position:'relative', top:'6px'}} /> Add Rule</span>
					</div>
				</div>

				<div style={{whiteSpace:'pre-line', fontSize:'12px', marginTop:'15px'}}>
					Audience Summary: <br />
					{this.app.resultsForm.getFriendlyAudienceName(experiment.rules) }
				</div>
			</div>
		);
	}
}





const Spacer = () => (<span style={{paddingLeft:'20px'}}></span>);




// WEBPACK FOOTER //
// ./src/components/ExperimentDetails.js